// extracted by mini-css-extract-plugin
export default {"reviewPhotoGallery":"sp-z","imageAndVideoCount":"tp-z","imageAndVideoContainer":"up-z","viewAllReviews":"vp-z"};